import React from 'react';
import ReactDOM from 'react-dom/client';
import '@sagano/station/styles/index.css';
import '@sagano/station/i18n';
import App from '@sagano/station/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
